import React, { PureComponent } from 'react'
import { Image, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

import { CellProps, ImageValue, CIRCLE } from './TableTypes'
import { getImageSize } from './utils'

class ImageCell extends PureComponent<CellProps> {
  static contextTypes = {
    getImageUploadsBaseURL: PropTypes.func,
  }

  render() {
    const { cell } = this.props
    const { getImageUploadsBaseURL } = this.context

    const imageValue = cell.value as ImageValue
    const imageRatio = cell.binding?.format?.imageRatio

    if (!imageValue || !imageRatio) return null

    const imageURL = `${getImageUploadsBaseURL()}/${imageValue.url}`
    const size = getImageSize(imageValue, imageRatio)
    const source = { uri: imageURL }

    switch (imageRatio) {
      case CIRCLE:
        return (
          <Image
            source={source}
            style={[styles.image, size, { borderRadius: size.width / 2 }]}
          />
        )
      default:
        return <Image source={source} style={[styles.image, size]} />
    }
  }
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    resizeMode: 'cover',
  },
})

export default ImageCell
